// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HeadMonth_wrapper____oQe","previous":"HeadMonth_previous__clUlJ"};